<template>
  <v2-card>
    <template #header>
      <span class="v2-font-semibold v2-text-sm">
        {{ order.shipmentId ? 'Shipment' : 'Order' }} Status
      </span>
    </template>
    <div class="v2-order-logs">
      <div
        v-for="log in order.logs"
        :key="log._id"
        class="v2-order-logs__item"
      >
        <div class="v2-order-logs__dot-container">
          <span
            class="v2-order-logs__dot"
            :class="getLogDotClass(log.status)"
          />
          <span class="v2-order-logs__line" />
        </div>
        <div class="v2-order-logs__content">
          <p class="v2-order-logs__title">
            {{ isRetailer ? (log.textForRetailers || log.status) : (log.textForBrands || log.status) }}
          </p>
          <span class="v2-order-logs__time">
            {{ showRelativeTime(log.timestamp) }}
          </span>
        </div>
      </div>
    </div>
  </v2-card>
</template>

<script>
import V2Card from '@/components/v2/V2Card.vue'
import { showRelativeTime } from '@/@core/utils/text'
import { parseOrderVariant } from '@/views/apps/order/order-utils'
import UserRoleMixin from '@/views/apps/UserRoleMixin.vue'

export default {
  name: 'V2OrderLogs',
  components: { V2Card },
  mixins: [UserRoleMixin],
  props: {
    order: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    showRelativeTime,
    getLogDotClass(status) {
      const variant = parseOrderVariant(status)
      const variantMap = {
        success: 'v2-order-logs__dot--success',
        danger: 'v2-order-logs__dot--danger',
        warning: 'v2-order-logs__dot--warning',
        info: 'v2-order-logs__dot--info',
        primary: 'v2-order-logs__dot--primary',
      }
      return variantMap[variant] || 'v2-order-logs__dot--default'
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-order-logs {
  max-height: 200px;
  overflow-y: auto;

  &__item {
    display: flex;
    gap: 0.75rem;
    padding-bottom: 0.75rem;

    &:last-child {
      padding-bottom: 0;

      .v2-order-logs__line {
        display: none;
      }
    }
  }

  &__dot-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 12px;
    padding-top: 4px;
  }

  &__dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;

    &--success { background-color: var(--v2-success); }
    &--danger { background-color: var(--v2-destructive); }
    &--warning { background-color: var(--v2-warning); }
    &--info, &--primary { background-color: var(--v2-primary); }
    &--default { background-color: var(--v2-muted-foreground); }
  }

  &__line {
    width: 2px;
    flex: 1;
    background-color: var(--v2-border);
    margin-top: 4px;
  }

  &__content {
    flex: 1;
    min-width: 0;
  }

  &__title {
    margin: 0;
    font-size: 0.8125rem;
    font-weight: 500;
    color: var(--v2-foreground);
    line-height: 1.3;
  }

  &__time {
    font-size: 0.75rem;
    color: var(--v2-muted-foreground);
  }
}
</style>
